/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import styles from './About.module.scss';
import { BASIC_CONTENT } from '../../../App.constant';
import BackGroundLayout from '../../BackGroundLayout/BackGroundLayout';


function About() {
  return (
    <div id='about' className={styles.container}>
      <BackGroundLayout backGroundText="About Me" overlapText="Know Me More" />
      <div className={styles.majorContent}>
        <div className={styles.leftContent}>
          <h2 className={styles.basicContent}>I'm <span className={styles.myName}>{BASIC_CONTENT?.name}</span>, a Web Developer</h2>
          <p className={styles.description}>{BASIC_CONTENT.description}</p>
        </div>
        <div className={styles.rightContent}>
          <ul>
            <li>
              <span className={styles.label}>Name: </span>
              <span className={styles.value}> {BASIC_CONTENT.name}</span>
            </li>
            <li>
              <span className={styles.label}>Email: </span>
              <a href='gmail.com' target='/blank'>{BASIC_CONTENT.email}</a>
            </li>
            <li>
              <span className={styles.label}>Age: </span>
              <span className={styles.value}> {BASIC_CONTENT.age}</span>
            </li>
            <li>
              <span className={styles.label}>From: </span>
              <span className={styles.value}> {BASIC_CONTENT.from}</span>
            </li>
          </ul>

        </div>
      </div>
    </div>
  )
}

export default About